import * as types from './constants'
import AxiosInstance from 'utils/AxiosInstance'
import { confirm } from 'dropzone'

export const setSearchValue = (searchValue) => ({
	type: types.SET_SEARCH_VALUE,
	searchValue,
})
export const onChangeRoleName = (value) => ({
	type: types.SET_ROLE_NAME,
	value,
})
export const onChangeRoleLevel = (value) => ({
	type: types.SET_ROLE_LEVEL,
	value,
})
export const toggleNewRoleOverlay = () => ({ type: types.TOGGLE_OVERLAY })
export const setCurrentRole = (value) => ({
	type: types.SET_CURRENT_ROLE,
	value,
})
export const onChangeCurrentRoleName = (value) => ({
	type: types.SET_CURRENT_ROLE_NAME,
	value,
})
export const onChangeCurrentRoleLevel = (value) => ({
	type: types.SET_CURRENT_ROLE_LEVEL,
	value,
})

export const fetchRoles = () => {
	return (dispatch, getState) => {
		dispatch({ type: types.SET_ROLES_LOADING, value: true })
		AxiosInstance.get(`/roles`).then((roles) => {
			dispatch({ type: types.SET_ROLES, roles })
			dispatch({ type: types.SET_ROLES_LOADING, value: false })
		})
	}
}

export const addNewRole = () => {
	return (dispatch, getState) => {
		const { roleName, roles, roleLevel } = getState().roles
		let language = {}
		// getState().language.language
		// 	? (language = getState().language.language.data)
		// 	: null
		if (!roleName) {
			alert(language.alerts ? language.alerts.type_role_name : null)
			return
		}

		const roleIndex = roles.findIndex(
			(item) => item.name.toLowerCase().trim() === roleName.toLowerCase().trim()
		)

		if (roleIndex === -1) {
			AxiosInstance.post('/roles', {
				name: roleName,
				level: roleLevel,
			}).then(() => {
				dispatch({ type: types.TOGGLE_OVERLAY, overlayIsShowing: false })
				dispatch({ type: types.SET_ROLE_NAME, roleName: '' })
				dispatch({ type: types.SET_ROLE_LEVEL, roleLevel: null })
				dispatch(fetchRoles())
			})
		} else {
			alert(language.alerts ? language.alerts.role_already_exists : null)
		}
	}
}

export const toggleEditOverlay = (item) => {
	return (dispatch) => {
		console.log(item, 'item in toggle edit')

		dispatch(setCurrentRole(item))
		dispatch({ type: types.TOGGLE_EDIT_OVERLAY })
	}
}

export const updateRole = () => {
	return (dispatch, getState) => {
		let language = {}
		getState().language.language //eslint-disable-line
			? (language = getState().language.language.data)
			: null
		const { currentRole } = getState().roles
		if (!currentRole.name) {
			alert(language.alerts ? language.alerts.type_role_name : null)
			return
		}

		AxiosInstance.put(`/roles/${currentRole.id}`, {
			name: currentRole.name,
			level: currentRole.level,
		}).then(() => {
			dispatch({ type: types.TOGGLE_EDIT_OVERLAY })
			dispatch(fetchRoles())
		})
	}
}

export const deleteRole = (id) => {
	return (dispatch, getState) => {
		let language = {}
		getState().language.language //eslint-disable-line
			? (language = getState().language.language.data)
			: null

		const confirmed = window.confirm(
			language.alerts && language.alerts.delete_role_confirm
				? language.alerts.delete_role_confirm
				: 'Do you want to delete this role?'
		)

		if (confirmed) {
			AxiosInstance.delete(`/roles/${id}`).then(() => {
				dispatch(fetchRoles())
			})
		}
	}
}

export const onClickSearch = () => {
	return (dispatch, getState) => {
		const value = getState().roles.searchValue
		dispatch({ type: types.SET_SEARCH_VALUE_ON_CLICK, value })
	}
}

export const onResetSearch = () => {
	return (dispatch) => {
		dispatch({ type: types.SET_SEARCH_VALUE_ON_CLICK, value: '' })
		dispatch({ type: types.SET_SEARCH_VALUE, value: '' })
	}
}
